import { render } from "./FilterVocabularyComponent.vue?vue&type=template&id=5b45d9f2&ts=true"
import script from "./FilterVocabularyComponent.vue?vue&type=script&lang=ts"
export * from "./FilterVocabularyComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__